/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.05"
        height="18.97"
        viewBox="0 0 19.05 18.97"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m4.19 6.17-2.1-2.1-2.11.59.11.47a15.42 15.42 0 0 0 1.84 4.2 2.1 2.1 0 0 0 2.11 1.07 7.59 7.59 0 0 0 2.8-.73c1 1.1 6.65 7.58 7.51 8.45a2.77 2.77 0 0 0 2 .85 2.65 2.65 0 0 0 2.68-2.74 2.76 2.76 0 0 0-.85-2c-.74-.74-5.61-5-8.5-7.48a8.16 8.16 0 0 0 .73-2.83 2.13 2.13 0 0 0-1.09-2.06A14.54 14.54 0 0 0 5.09.05l-.46-.1-.64 2.17L6.1 4.24a3.6 3.6 0 0 1-.74 1.07 4.48 4.48 0 0 1-1.17.86Zm3-2v-.22L5.13 1.88l.2-.68a13.56 13.56 0 0 1 3.45 1.55 1.14 1.14 0 0 1 .64 1.17 6.82 6.82 0 0 1-.81 2.79l-.11.39.29.25c5 4.32 8.16 7.11 8.7 7.65a1.74 1.74 0 0 1 .55 1.23 1.76 1.76 0 0 1-.48 1.27 1.73 1.73 0 0 1-1.26.48 1.68 1.68 0 0 1-1.22-.57c-.71-.71-5.19-5.8-7.73-8.7l-.28-.31-.35.2a6.24 6.24 0 0 1-2.79.8 1.08 1.08 0 0 1-1.14-.61 14.9 14.9 0 0 1-1.58-3.44l.61-.17 2.1 2.11.27-.05a4.89 4.89 0 0 0 1.89-1.17 4 4 0 0 0 1.11-1.9Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'WrenchIcon';

export default Icon;
